import { useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
//
import getValidationErrors from "../../../utils/getValidationErrors";
import api from "../../../services/api";
import LoadingIndicator from "../../../components/LoadingIndicator";
import logoBrainPay from "../../../assets/images/logo_brainpay.png";
import logoLyPago from "../../../assets/images/logo_lypago.png";
// import "./styles.css";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required("The Email field is required")
    .email("Type a valid email address"),
});

function RecoverPassword() {
  // const [fieldsValues, setFieldsValues] = useState({
  //   email: "",
  //   password: "",
  // });
  const [fieldsValues, setFieldsValues] = useState({});
  const [errors, setErrors] = useState([]);
  const [successMsgs, setSuccessMsgs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFieldChange = (event) => {
    const auxFieldsValues = { ...fieldsValues };
    auxFieldsValues[event.target.name] = event.target.value;
    setFieldsValues(auxFieldsValues);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setErrors([]);
      setSuccessMsgs([]);
      setIsLoading(true);
      await validationSchema.validate(fieldsValues, {
        abortEarly: false,
      });

      const response = await api.post(
        "/v1/auth/company/account/recover",
        fieldsValues
      );
      setIsLoading(false);
      // console.log(response);
      if (response.data && response.data.code !== 200) {
        setErrors([response.data.message]);
      } else {
        setSuccessMsgs([
          "SUCCESS: access your email and click on the link sent",
        ]);
        // alert("SUCCESS: access your email and click on the link sent")
      }
    } catch (error) {
      // console.log(error);
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        let validationErrors = [];
        Object.keys(errors).forEach((key) => {
          validationErrors.push(errors[key]);
        });
        setErrors(validationErrors);
        setIsLoading(false);
        return;
      }
    }
  };

  return (
    <div className="auth-form-container">
      {/* <h2>{process.env.REACT_APP_GATEWAY_NAME} - Recover Password</h2> */}
      <img
        src={
          process.env.REACT_APP_GATEWAY_NAME === "BrainPay"
            ? logoBrainPay
            : logoLyPago
        }
        alt={process.env.REACT_APP_GATEWAY_NAME}
        className="logo-img"
      />
      {errors.length > 0 && (
        <div className="alert alert-danger">
          {errors.map((err, index) => (
            <span key={index}>{err}</span>
          ))}
        </div>
      )}
      {successMsgs.length > 0 && (
        <div className="alert alert-success">
          {successMsgs.map((msg, index) => (
            <span key={index}>{msg}</span>
          ))}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email*"
          onChange={handleFieldChange}
          className="form-group form-control"
          // value={fieldsValues["email"]}
        />
        {isLoading && <LoadingIndicator />}
        {!isLoading && (
          <>
            <button type="submit" className="btn btn-default btn-block">
              Recover password
            </button>
            <Link to="/">Back to Login</Link>
          </>
        )}
      </form>
    </div>
  );
}

export default RecoverPassword;
